import Yup from '../../../utilities/yupExtensions';

export const monitorinqueueValidationSchema = Yup.object({
  type: Yup.string().required("Error"),
})


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/validation-schemas/monitorinqueueValidationSchema.js